module.exports = __webpack_public_path__ + "img/bixiu.5f987dac.png";